import React from 'react';
import DiningSlider from './partials/dinslider';
import { useState, useEffect, useRef } from 'react';

const Dining = () => {
  const [activeTab, setActiveTab] = useState('A');
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  const handleTabChange = (tabId) => {
    setActiveTab(tabId);
  };

  // Scroll-triggered animation using Intersection Observer
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // Add a small delay for smooth animation
            setTimeout(() => {
              setIsVisible(true);
            }, 200);
            // Stop observing once animation is triggered
            observer.unobserve(entry.target);
          }
        });
      },
      {
        threshold: 0.1, // Trigger when 10% of the section is visible
        rootMargin: '0px 0px -50px 0px' // Trigger slightly before section is fully visible
      }
    );

    const currentSectionRef = sectionRef.current;
    if (currentSectionRef) {
      observer.observe(currentSectionRef);
    }

    return () => {
      if (currentSectionRef) {
        observer.unobserve(currentSectionRef);
      }
    };
  }, []);
  
  return (
    <>
      <main>
        <DiningSlider />

      <div className="petti_din_bg">
        <div className="container margin_120_95">
          <div className="row justify-content-between align-items-center">
            <div className="col-lg-6 whitetext">
              <div className="intro">
                <div className="title">
                  <h2 className="whitetext">SEABREEZE SERANADE:<br />A CULINARY OASIS BY THE SEA</h2>
                </div>
                <p className="lead" style={{ fontWeight: '400' }}>
                  Boasting an unparalleled dining experience, our seafood is hand-picked fresh daily. Alongside this, our acclaimed chefs merge creative flavours to timeless dishes. This commitment helps us provide one of the most unique blend of flavours throughout the southern coast.
                </p>
              </div>
            </div>
            <div className="col-lg-6 col-12 whitetext">
              <div>
                <ul className="list-unstyled mb-4">
                  <li className="d-flex justify-content-between mb-2 text-end">
                    <strong>Breakfast</strong> <span>8am – 12pm</span>
                  </li>
                  <li className="d-flex justify-content-between mb-2 text-end">
                    <strong>All day dining</strong>
                    <span>
                      12pm - 11.30pm<br />
                      <small>(Kitchen close at 10pm)</small><br />
                      <small>(Bar close at 11.30pm)</small>
                    </span>
                  </li>
                </ul>
                <p className="phone_element">
                  <a href="tel:+94761407881">
                    <i className="bi bi-telephone" style={{ color: '#fff' }}></i>
                    <span style={{ color: '#fff' }}>
                      <em style={{ color: '#fff' }}>Reservations</em>+94 76 140 7881
                    </span>
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="petti_cream_din_rep" ref={sectionRef}>
        <div className="container margin_80_55" id="first_section">
          <div className="title text-center mb-5">
            <small className={`animate-slide-up ${isVisible ? 'animate-visible' : ''}`} style={{ animationDelay: '0.1s' }}>
              Sip, Savor and Sea
            </small>
            <h2 className={`animate-slide-up ${isVisible ? 'animate-visible' : ''}`} style={{ animationDelay: '0.2s' }}>
              À LA CARTE MENU
            </h2>
          </div>
          {/* Mobile accordion (visible < lg) */}
          <div className={`tabs_menu animate-slide-up d-lg-none ${isVisible ? 'animate-visible' : ''}`} style={{ animationDelay: '0.3s' }}>
            <div className="tab-content add_bottom_25" role="tablist">
              <div id="pane-A" className="card tab-pane fade show active" role="tabpanel" aria-labelledby="tab-A">
                <div className="card-header" role="tab" id="heading-A">
                  <h5>
                    <a className="collapsed" data-bs-toggle="collapse" href="#collapse-A" aria-expanded="false" aria-controls="collapse-A">
                      BREAKFAST
                    </a>
                  </h5>
                </div>
                <div id="collapse-A" className="collapse" role="tabpanel" aria-labelledby="heading-A">
                  <div className="card-body text-center">
                    <div className="row magnific-gallery add_top_30">
                      <div className="col-12 col-sm-6">
                        <div className="menu_item menupadding text-center">
                          <div className="menu_title">
                            <h3>RISE & SHINE</h3>
                          </div>
                          <p>Cheese | Baked Beans | Tomato | Spinach | Mushroom<br />Chicken Sausage | Bacon | Toast Bread | Jam | Butter</p>
                        </div>
                      </div>
                      <div className="col-12 col-sm-6">
                        <div className="menu_item menupadding">
                          <div className="menu_title">
                            <h3>EGGS BENEDICT & CRIPSY COCNUT SAMBAL</h3>
                          </div>
                          <p>Egg | Bacon | Spinach | Coconut</p>
                        </div>
                      </div>
                      <div className="col-12 col-sm-6">
                        <div className="menu_item menupadding">
                          <div className="menu_title">
                            <h3>TROPICAL GRANOLA BOWL</h3>
                          </div>
                          <p>Yoghurt | Museli | Tropical Fresh Fruits</p>
                        </div>
                      </div>
                      <div className="col-12 col-sm-6">
                        <div className="menu_item menupadding">
                          <div className="menu_title">
                            <h3>AVOCADO & PUMPKIN TOAST<br />WITH POACHED EGG</h3>
                          </div>
                          <p>Multigrain Bread | Avocado | Egg | Tahini Paste | Pumpkin</p>
                        </div>
                      </div>
                      <div className="col-12 col-sm-6">
                        <div className="menu_item menupadding">
                          <div className="menu_title">
                            <h3>FRENCH TOAST WITH KITHUL TREACLE</h3>
                          </div>
                          <p>Cinnamon | Strawberry | Banana | Ice Cream | Treacle</p>
                        </div>
                      </div>
                      <div className="col-12 col-sm-6">
                        <div className="menu_item menupadding">
                          <div className="menu_title">
                            <h3>TURKISH STYLE EGG</h3>
                          </div>
                          <p>Egg | Yogurt | Chilli Oil | Multigrain Bread</p>
                        </div>
                      </div>
                      <div className="col-12 col-sm-6">
                        <div className="menu_item menupadding">
                          <div className="menu_title">
                            <h3>MILK RICE IN COCONUT PRAWN<br />WITH CARAMELIZED ONION</h3>
                          </div>
                          <p>Prawn | Milk Rice | Coconut Milk | Caramelized Onion</p>
                        </div>
                      </div>
                      <div className="col-12 col-sm-6">
                        <div className="menu_item menupadding">
                          <div className="menu_title">
                            <h3>STRING HOPPERS</h3>
                          </div>
                          <p>Dhal | Coconut Sambal | (Chicken/Fish)</p>
                        </div>
                      </div>
                      <div className="col-12 title text-center mb-5">
                        <h3 className="darkcolor">ADD ONS</h3>
                      </div>
                      <div className="col-12 col-sm-6">
                        <div className="menu_item menupadding">
                          <div className="menu_title">
                            <h3>CHILLI BACON BUTTER</h3>
                          </div>
                        </div>
                      </div>
                      <div className="col-12 col-sm-6">
                        <div className="menu_item menupadding">
                          <div className="menu_title">
                            <h3>BROWN TOAST</h3>
                          </div>
                        </div>
                      </div>
                      <div className="col-12 col-sm-6">
                        <div className="menu_item menupadding">
                          <div className="menu_title">
                            <h3>PUMPKIN HUMMUS</h3>
                          </div>
                        </div>
                      </div>
                      <div className="col-12 col-sm-6">
                        <div className="menu_item menupadding">
                          <div className="menu_title">
                            <h3>EGG ANY STYLE</h3>
                          </div>
                        </div>
                      </div>
                      <p className="col-12 darkcolor">ALL PRICES ARE IN LKR & SUBJECT TO 10% SERVICE CHARGE + 01% GOVERNMENT TAX</p>
                    </div>
                  </div>
                </div>
              </div>
              <div id="pane-B" className="card tab-pane fade" role="tabpanel" aria-labelledby="tab-B">
                <div className="card-header" role="tab" id="heading-B">
                  <h5>
                    <a className="collapsed" data-bs-toggle="collapse" href="#collapse-B" aria-expanded="true" aria-controls="collapse-B">
                      ALL DAY DINING
                    </a>
                  </h5>
                </div>
                <div id="collapse-B" className="collapse" role="tabpanel" aria-labelledby="heading-B">
                  <div className="card-body text-center">
                    <div className="row magnific-gallery add_top_30">
                      <div className="col-12">
                        <div className="title text-center mb-5">
                          <h3 className="darkcolor">APPETIZER</h3>
                        </div>
                      </div>
                      <div className="col-12 col-sm-6">
                        <div className="menu_item menupadding text-center">
                          <div className="menu_title">
                            <h3>SWEET POTATO NACHOS</h3>
                          </div>
                          <p>Sweet potato | Sour cream | Guacamole | Cheese</p>
                        </div>
                      </div>
                      <div className="col-12 col-sm-6">
                        <div className="menu_item menupadding text-center">
                          <div className="menu_title">
                            <h3>LEMONGRASS & CURRY INFUSED CHICKEN SKEWERS</h3>
                          </div>
                          <p>Chicken | Peanut butter | Lemongrass</p>
                        </div>
                      </div>
                      <div className="col-12 col-sm-6">
                        <div className="menu_item menupadding text-center">
                          <div className="menu_title">
                            <h3>PRAWN ROTI</h3>
                          </div>
                          <p>Prawns | Cheese | Bell peppers | Tamarind</p>
                        </div>
                      </div>
                      <div className="col-12 col-sm-6">
                        <div className="menu_item menupadding text-center">
                          <div className="menu_title">
                            <h3>MANIOC ARANCINI</h3>
                          </div>
                          <p>Manioc | Cheese | Spiced kochchi</p>
                        </div>
                      </div>
                      <div className="col-12 col-sm-6">
                        <div className="menu_item menupadding text-center">
                          <div className="menu_title">
                            <h3>TUNA SASHIMI</h3>
                          </div>
                          <p>Yellowfin tuna | Pickle ginger | Radish | Wasabi | Greens</p>
                        </div>
                      </div>
                      <div className="col-12 col-sm-6">
                        <div className="menu_item menupadding text-center">
                          <div className="menu_title">
                            <h3>TUNA TARTARE</h3>
                          </div>
                          <p>Yellowfin tuna | Avocado | Lemon | Cilantro | Sesame</p>
                        </div>
                      </div>
                      <div className="col-12 title text-center mb-5">
                        <h3 className="darkcolor">SALADS</h3>
                      </div>
                      <div className="col-12 col-sm-6">
                        <div className="menu_item menupadding text-center">
                          <div className="menu_title">
                            <h3>POACHED YELLOWFIN TUNA</h3>
                          </div>
                          <p>Yellowfin tuna | Greens | Tomato | Beans | Tamarind | Jaggery</p>
                        </div>
                      </div>
                      <div className="col-12 col-sm-6">
                        <div className="menu_item menupadding text-center">
                          <div className="menu_title">
                            <h3>ASIAN FLAVORED PRAWN NOODLES SALAD</h3>
                          </div>
                          <p>Prawns | Kurakkan noodles | Cilantro | Mango | Sesame oil | Spring onion</p>
                        </div>
                      </div>
                      <div className="col-12 col-sm-6">
                        <div className="menu_item menupadding text-center">
                          <div className="menu_title">
                            <h3>BHEALTHY GREENS WITH TROPICAL FRUITS</h3>
                          </div>
                          <p>Greens | Gotukola | Fruits</p>
                        </div>
                      </div>
                      <div className="col-12 title text-center mb-5">
                        <h3 className="darkcolor">SOUP</h3>
                      </div>
                      <div className="col-12 col-sm-6">
                        <div className="menu_item menupadding text-center">
                          <div className="menu_title">
                            <h3>LEMONGRASS & CRAYFISH BISQUE</h3>
                          </div>
                          <p>Crayfish | Lemongrass | Tomato</p>
                        </div>
                      </div>
                      <div className="col-12 col-sm-6">
                        <div className="menu_item menupadding text-center">
                          <div className="menu_title">
                            <h3>COCONUT SEAFOOD BROTH</h3>
                          </div>
                          <p>Mixed seafood | Curry coconut cream</p>
                        </div>
                      </div>
                      <div className="col-12 col-sm-6">
                        <div className="menu_item menupadding text-center">
                          <div className="menu_title">
                            <h3>ORANGE FLAVORED CARROT SOUP</h3>
                          </div>
                          <p>Carrot | Orange | Habalapeti</p>
                        </div>
                      </div>
                      <div className="col-12 title text-center mb-5">
                        <h3 className="darkcolor">SIDE DISHES</h3>
                      </div>
                      <div className="col-12 col-sm-6">
                        <div className="menu_item menupadding text-center">
                          <div className="menu_title">
                            <h3>HOME-MADE FRIES</h3>
                          </div>
                        </div>
                      </div>
                      <div className="col-12 col-sm-6">
                        <div className="menu_item menupadding text-center">
                          <div className="menu_title">
                            <h3>SWEET POTATO FRIES</h3>
                          </div>
                        </div>
                      </div>
                      <div className="col-12 col-sm-6">
                        <div className="menu_item menupadding text-center">
                          <div className="menu_title">
                            <h3>GARLIC TOAST</h3>
                          </div>
                        </div>
                      </div>
                      <div className="col-12 col-sm-6">
                        <div className="menu_item menupadding text-center">
                          <div className="menu_title">
                            <h3>LEMONGRASS FLOURED SAFFRON RICE BOWL</h3>
                          </div>
                        </div>
                      </div>
                      <div className="col-12 title text-center mb-5">
                        <h3 className="darkcolor">HANDHELDS</h3>
                      </div>
                      <div className="col-12 col-sm-6">
                        <div className="menu_item menupadding text-center">
                          <div className="menu_title">
                            <h3>CRISPY CHICKEN BURGER</h3>
                          </div>
                          <p>Chicken | Cheese | Tomato | Lettuce | Fries</p>
                        </div>
                      </div>
                      <div className="col-12 col-sm-6">
                        <div className="menu_item menupadding text-center">
                          <div className="menu_title">
                            <h3>BEEF BURGER</h3>
                          </div>
                          <p>Beef | Caramalized onion | Cheese | Lettuce | Tomato | Fries</p>
                        </div>
                      </div>
                      <div className="col-12 col-sm-6">
                        <div className="menu_item menupadding text-center">
                          <div className="menu_title">
                            <h3>PRAWN BURGER</h3>
                          </div>
                          <p>Prawn | Cheese | Lettuce | Tomato | Fries</p>
                        </div>
                      </div>
                      <div className="col-12 col-sm-6">
                        <div className="menu_item menupadding text-center">
                          <div className="menu_title">
                            <h3>POLOS BURGER</h3>
                          </div>
                          <p>Baby jack fruit | Caramelized onion | Cheese | Passion leaves | Fries</p>
                        </div>
                      </div>
                      <div className="col-12 title text-center mb-5">
                        <h3 className="darkcolor">MAINS</h3>
                      </div>
                      <div className="col-12 col-sm-6">
                        <div className="menu_item menupadding text-center">
                          <div className="menu_title">
                            <h3>CURRY GRAVY IN JUMBO PRAWN & PITTU</h3>
                          </div>
                          <p>Jumbo prawn | Coconut cream | Casava pittu | Kankun</p>
                        </div>
                      </div>
                      <div className="col-12 col-sm-6">
                        <div className="menu_item menupadding text-center">
                          <div className="menu_title">
                            <h3>SEAFOOD PLATTER</h3>
                          </div>
                          <p>Jumbo prawns | Fish steak | Calamari | Crab | Fries | Greens salad | Garlic butter sauce</p>
                        </div>
                      </div>
                      <div className="col-12 col-sm-6">
                        <div className="menu_item menupadding text-center">
                          <div className="menu_title">
                            <h3>GRILLED FILLET BARRAMUNDI & SALSA VERDE</h3>
                          </div>
                          <p>Potato | Spinach | Aper butter | Salsa verde</p>
                        </div>
                      </div>
                      <div className="col-12 col-sm-6">
                        <div className="menu_item menupadding text-center">
                          <div className="menu_title">
                            <h3>YELLOWFIN TUNA STEAK</h3>
                          </div>
                          <p>Yellowfin tuna | Saffron rice | Mango salsa | Gotukola | Lemon butter</p>
                        </div>
                      </div>
                      <div className="col-12 col-sm-6">
                        <div className="menu_item menupadding text-center">
                          <div className="menu_title">
                            <h3>POT-ROAST CHICKEN THIGH (BONELESS)</h3>
                          </div>
                          <p>Sri Lankan spices | Chicken | Pumpkin | Broccoli | Green pepper sauce</p>
                        </div>
                      </div>
                      <div className="col-12 col-sm-6">
                        <div className="menu_item menupadding text-center">
                          <div className="menu_title">
                            <h3>PORK CURRY WITH POL ROTI</h3>
                          </div>
                          <p>Pork | Sri Lankan spices | Coconut sambal</p>
                        </div>
                      </div>
                      <div className="col-12 col-sm-6">
                        <div className="menu_item menupadding text-center">
                          <div className="menu_title">
                            <h3>SEAFOOD HOT POT & CRUSTY BREAD</h3>
                          </div>
                          <p>Crab | Fish | Cuttlefish | Prawns | Bread | Coconut gravy | Pol sambal</p>
                        </div>
                      </div>
                      <div className="col-12 col-sm-6">
                        <div className="menu_item menupadding text-center">
                          <div className="menu_title">
                            <h3>FETTUCCINE IN SPICED LOKU PRAWNS CURRY SAUCE</h3>
                          </div>
                          <p>Loku (big) prawns | Cheese | Fettuccine | Coconut cream</p>
                        </div>
                      </div>
                      <div className="col-12 col-sm-6">
                        <div className="menu_item menupadding text-center">
                          <div className="menu_title">
                            <h3>LEMON & GARLIC MARINATED GRILLED CALAMARI</h3>
                          </div>
                          <p>Loku (big) prawns | Cheese | Fettuccine | Coconut cream</p>
                        </div>
                      </div>
                      <div className="col-12 col-sm-6">
                        <div className="menu_item menupadding text-center">
                          <div className="menu_title">
                            <h3>PRAWN RISOTTO</h3>
                          </div>
                          <p>Loku (big) prawns | Cheese | Fettuccine | Coconut cream</p>
                        </div>
                      </div>
                      <div className="col-12 col-sm-6">
                        <div className="menu_item menupadding text-center">
                          <div className="menu_title">
                            <h3>SPAGHETTI WITH SPICED CRAB MEAT</h3>
                          </div>
                          <p>Crab meat | Spaghetti | Chili | Cheese</p>
                        </div>
                      </div>
                      <div className="col-12 col-sm-6">
                        <div className="menu_item menupadding text-center">
                          <div className="menu_title">
                            <h3>PASTA ARRABIATA</h3>
                          </div>
                          <p>Penne | Fresh tomato | Chili | Parmesan cheese | Basil</p>
                        </div>
                      </div>
                      <div className="col-12 col-sm-6">
                        <div className="menu_item menupadding text-center">
                          <div className="no_menu_title">
                            <h3>RICE & CURRY BOWL</h3>
                          </div>
                          <p>Typical rice & curry served with four veg curries salad and papadam
                            <ul>
                              <li className="menu_title"><h6>- Prawns</h6></li>
                              <li className="menu_title"><h6>- Fish</h6></li>
                              <li className="menu_title"><h6>- Crabs</h6></li>
                              <li className="menu_title"><h6>- Chicken</h6></li>
                              <li className="menu_title"><h6>- Vegetable</h6></li>
                            </ul>
                          </p>
                        </div>
                      </div>
                      <div className="col-12 title text-center mb-5">
                        <h3 className="darkcolor">DESSERTS</h3>
                      </div>
                      <div className="col-12 col-sm-6">
                        <div className="menu_item menupadding text-center">
                          <div className="menu_title">
                            <h3>COCONUT CRÈME BRULEE</h3>
                          </div>
                          <p>Coconut | Crème</p>
                        </div>
                      </div>
                      <div className="col-12 col-sm-6">
                        <div className="menu_item menupadding text-center">
                          <div className="menu_title">
                            <h3>MANGO TIRAMISU</h3>
                          </div>
                          <p>Mascarpone cheese | Cocoa | Kahlua | Mango</p>
                        </div>
                      </div>
                      <div className="col-12 col-sm-6">
                        <div className="menu_item menupadding text-center">
                          <div className="menu_title">
                            <h3>CHOCOLATE BROWNIE</h3>
                          </div>
                          <p>Chocolate | Cashew | Ice cream</p>
                        </div>
                      </div>
                      <div className="col-12 col-sm-6">
                        <div className="menu_item menupadding text-center">
                          <div className="menu_title">
                            <h3>CARAMELIZED COCONUTS WITH CHOCOLATE CREPES</h3>
                          </div>
                          <p>Chocolate | Caramelized coconut | Ice cream</p>
                        </div>
                      </div>
                      <div className="col-12 col-sm-6">
                        <div className="menu_item menupadding text-center">
                          <div className="menu_title">
                            <h3>CHOICE OF ICE CREAM</h3>
                          </div>
                        </div>
                      </div>
                      <p className="col-12 darkcolor">ALL PRICES ARE IN LKR & SUBJECT TO 10% SERVICE CHARGE + 01% GOVERNMENT TAX</p>
                    </div>
                  </div>
                </div>
              </div>
              <div id="pane-C" className="card tab-pane fade" role="tabpanel" aria-labelledby="tab-C">
                <div className="card-header" role="tab" id="heading-C">
                  <h5>
                    <a className="collapsed" data-bs-toggle="collapse" href="#collapse-C" aria-expanded="true" aria-controls="collapse-C">
                      YOUNG TRAVELER
                    </a>
                  </h5>
                </div>
                <div id="collapse-C" className="collapse" role="tabpanel" aria-labelledby="heading-C">
                  <div className="card-body text-center">
                    <div className="row magnific-gallery add_top_30">
                      <div className="col-12 col-sm-6">
                        <div className="menu_item menupadding text-center">
                          <div className="menu_title">
                            <h3>SPAGHETTI CARBONARA</h3>
                          </div>
                        </div>
                      </div>
                      <div className="col-12 col-sm-6">
                        <div className="menu_item menupadding text-center">
                          <div className="menu_title">
                            <h3>POTATO MASHED WITH GRILLED SAUSAGE</h3>
                          </div>
                        </div>
                      </div>
                      <div className="col-12 col-sm-6">
                        <div className="menu_item menupadding text-center">
                          <div className="menu_title">
                            <h3>CHEESE CHICKEN BURGER WITH FRIES</h3>
                          </div>
                        </div>
                      </div>
                      <div className="col-12 col-sm-6">
                        <div className="menu_item menupadding text-center">
                          <div className="menu_title">
                            <h3>MAC & CHEESE</h3>
                          </div>
                        </div>
                      </div>
                      <div className="col-12 col-sm-6">
                        <div className="menu_item menupadding text-center">
                          <div className="menu_title">
                            <h3>FISH FINGERS WITH FRIES</h3>
                          </div>
                        </div>
                      </div>
                      <p className="col-12 darkcolor">ALL PRICES ARE IN LKR & SUBJECT TO 10% SERVICE CHARGE + 01% GOVERNMENT TAX</p>
                    </div>
                  </div>
                </div>
              </div>
              <div id="pane-D" className="card tab-pane fade" role="tabpanel" aria-labelledby="tab-D">
                <div className="card-header" role="tab" id="heading-D">
                  <h5>
                    <a className="collapsed" data-bs-toggle="collapse" href="#collapse-D" aria-expanded="true" aria-controls="collapse-D">
                      DRINKS
                    </a>
                  </h5>
                </div>
                <div id="collapse-D" className="collapse" role="tabpanel" aria-labelledby="heading-D">
                  <div className="card-body text-center">
                    <div className="row magnific-gallery add_top_30">
                      <div className="col-12 title text-center mb-5">
                        <h3 className="darkcolor">COCKTAILS</h3>
                      </div>
                      <div className="col-12 col-sm-6">
                        <div className="menu_item menupadding text-center">
                          <div className="menu_title">
                            <h3>ORYZA FIZZ</h3>
                          </div>
                          <p>Gin | Ginger | Lemon Grass | Sprite</p>
                        </div>
                      </div>
                      <div className="col-12 col-sm-6">
                        <div className="menu_item menupadding text-center">
                          <div className="menu_title">
                            <h3>PETTI PASSION</h3>
                          </div>
                          <p>Arrack | Passion | Pineapple | Mint | Soda</p>
                        </div>
                      </div>
                      <div className="col-12 col-sm-6">
                        <div className="menu_item menupadding text-center">
                          <div className="menu_title">
                            <h3>MIRISSA ACHCHARUWA</h3>
                          </div>
                          <p>Gin | Triple Sec | Lime | Local Achcharu</p>
                        </div>
                      </div>
                      <div className="col-12 col-sm-6">
                        <div className="menu_item menupadding text-center">
                          <div className="menu_title">
                            <h3>CURRY MELON TEQUILA</h3>
                          </div>
                          <p>Tequila | Watermelon | Lime | Sugar</p>
                        </div>
                      </div>
                      <div className="col-12 col-sm-6">
                        <div className="menu_item menupadding text-center">
                          <div className="menu_title">
                            <h3>CINNAMON TWIST</h3>
                          </div>
                          <p>Vodka | Triple Sec | Lime | Cinnamon</p>
                        </div>
                      </div>
                      <div className="col-12 col-sm-6">
                        <div className="menu_item menupadding text-center">
                          <div className="menu_title">
                            <h3>ESPRESSO MILO TINI</h3>
                          </div>
                          <p>Vodka | Caoco brown | Expresso | Milo</p>
                        </div>
                      </div>
                      <div className="col-12 title text-center mb-5">
                        <h3 className="darkcolor">WINE</h3>
                      </div>
                      <div className="col-12 title text-center mb-5">
                        <h4>WHITE WINE</h4>
                      </div>
                      <div className="col-12 col-sm-6">
                        <div className="menu_item menupadding text-center">
                          <div className="menu_title">
                            <h3 className="upper">Cono Sur Bicicleta Sauvignon Blanc, Chile</h3>
                          </div>
                        </div>
                      </div>
                      <div className="col-12 col-sm-6">
                        <div className="menu_item menupadding text-center">
                          <div className="menu_title">
                            <h3 className="upper">Paraiso White, Chile</h3>
                          </div>
                        </div>
                      </div>
                      <div className="col-12 col-sm-6">
                        <div className="menu_item menupadding text-center">
                          <div className="menu_title">
                            <h3 className="upper">Yellow tail Sauvignon Blanc, Australia</h3>
                          </div>
                        </div>
                      </div>
                      <div className="col-12 col-sm-6">
                        <div className="menu_item menupadding text-center">
                          <div className="menu_title">
                            <h3 className="upper">Dr. Loosen Riesling, Germany</h3>
                          </div>
                        </div>
                      </div>
                      <div className="col-12 col-sm-6">
                        <div className="menu_item menupadding text-center">
                          <div className="menu_title">
                            <h3 className="upper">Santa Margherita Pinot Grigio DOC, Italy</h3>
                          </div>
                        </div>
                      </div>
                      <div className="col-12 title text-center mb-5">
                        <h4>RED WINE</h4>
                      </div>
                      <div className="col-12 col-sm-6">
                        <div className="menu_item menupadding text-center">
                          <div className="menu_title">
                            <h3 className="upper">Cono Sur Bicicleta Cabernet Sauvignon</h3>
                          </div>
                        </div>
                      </div>
                      <div className="col-12 col-sm-6">
                        <div className="menu_item menupadding text-center">
                          <div className="menu_title">
                            <h3 className="upper">Paraiso Red, Chile</h3>
                          </div>
                        </div>
                      </div>
                      <div className="col-12 col-sm-6">
                        <div className="menu_item menupadding text-center">
                          <div className="menu_title">
                            <h3 className="upper">Tall Horse Pinotage, South Africa</h3>
                          </div>
                        </div>
                      </div>
                      <div className="col-12 title text-center mb-5">
                        <h4>ROSÉ WINE</h4>
                      </div>
                      <div className="col-12 col-sm-6">
                        <div className="menu_item menupadding text-center">
                          <div className="menu_title">
                            <h3 className="upper">Jam Jar Sweet Blush, South Africa</h3>
                          </div>
                        </div>
                      </div>
                      <div className="col-12 col-sm-6">
                        <div className="menu_item menupadding text-center">
                          <div className="menu_title">
                            <h3 className="upper">Torresella Pinot Grigio Rose, Italy</h3>
                          </div>
                        </div>
                      </div>
                      <div className="col-12 title text-center mb-5">
                        <h4>SPARKLING / CHAMPAGNE</h4>
                      </div>
                      <div className="col-12 col-sm-6">
                        <div className="menu_item menupadding text-center">
                          <div className="menu_title">
                            <h3 className="upper">EGOS Spumante Brut, Italy</h3>
                          </div>
                        </div>
                      </div>
                      <div className="col-12 col-sm-6">
                        <div className="menu_item menupadding text-center">
                          <div className="menu_title">
                            <h3 className="upper">Torresella Prosecco, Italy</h3>
                          </div>
                        </div>
                      </div>
                      <div className="col-12 col-sm-6">
                        <div className="menu_item menupadding text-center">
                          <div className="menu_title">
                            <h3 className="upper">Jacquart Brut Mosaique, France</h3>
                          </div>
                        </div>
                      </div>
                      <div className="col-12 col-sm-6">
                        <div className="menu_item menupadding text-center">
                          <div className="menu_title">
                            <h3 className="upper">Pierre Mignon Grande Reserve Brut, France</h3>
                          </div>
                        </div>
                      </div>
                      <div className="col-12 col-sm-6">
                        <div className="menu_item menupadding text-center">
                          <div className="menu_title">
                            <h3 className="upper">Pierre Mignon Rose Brut, France</h3>
                          </div>
                        </div>
                      </div>
                      <div className="col-12 col-sm-6">
                        <div className="menu_item menupadding text-center">
                          <div className="menu_title">
                            <h3 className="upper">Moet Chandon Brut, France</h3>
                          </div>
                        </div>
                      </div>
                      <p className="col-12 darkcolor">ALL PRICES ARE IN LKR & SUBJECT TO 10% SERVICE CHARGE + 01% GOVERNMENT TAX</p>
                    </div>
                  </div>
                </div>
              </div>
              <div id="pane-E" className="card tab-pane fade" role="tabpanel" aria-labelledby="tab-E">
                <div className="card-header" role="tab" id="heading-E">
                  <h5>
                    <a className="collapsed" data-bs-toggle="collapse" href="#collapse-E" aria-expanded="true" aria-controls="collapse-E">
                      NON ALCOHOLIC
                    </a>
                  </h5>
                </div>
                <div id="collapse-E" className="collapse" role="tabpanel" aria-labelledby="heading-E">
                  <div className="card-body text-center">
                    <div className="row magnific-gallery add_top_30">
                      <div className="col-12 col-sm-6">
                        <div className="menu_item menupadding text-center">
                          <div className="menu_title">
                            <h3>VIRGIN PASSION MOJITO</h3>
                          </div>
                          <p>Passion | Mint | Lime | Sprite</p>
                        </div>
                      </div>
                      <div className="col-12 col-sm-6">
                        <div className="menu_item menupadding text-center">
                          <div className="menu_title">
                            <h3>WATERMELON COOLER</h3>
                          </div>
                          <p>Watermelon | Mint | Lime</p>
                        </div>
                      </div>
                      <div className="col-12 col-sm-6">
                        <div className="menu_item menupadding text-center">
                          <div className="menu_title">
                            <h3>FRESCO</h3>
                          </div>
                          <p>Ginger | Lime | Mint | Ginger ale</p>
                        </div>
                      </div>
                      <div className="col-12 col-sm-6">
                        <div className="menu_item menupadding text-center">
                          <div className="menu_title">
                            <h3>CEYLON GINGER & MINT TEA</h3>
                          </div>
                          <p>Black tea | Ginger | Cinnamon | Mint | Sugar</p>
                        </div>
                      </div>
                      <div className="col-12 col-sm-6">
                        <div className="menu_item menupadding text-center">
                          <div className="menu_title">
                            <h3>GREEN MINT TEA</h3>
                          </div>
                          <p>Green tea | Lime | Kithul treacle | Mint</p>
                        </div>
                      </div>
                      <div className="col-12">
                        <div className="title text-center mb-5">
                          <h3 className="darkcolor">JUICES</h3>
                        </div>
                      </div>
                      <div className="col-12 col-sm-6">
                        <div className="menu_item menupadding text-center">
                          <div className="menu_title">
                            <h3>MANGO</h3>
                          </div>
                        </div>
                      </div>
                      <div className="col-12 col-sm-6">
                        <div className="menu_item menupadding text-center">
                          <div className="menu_title">
                            <h3>PINEAPPLE | WATERMELON | PASSION</h3>
                          </div>
                        </div>
                      </div>
                      <div className="col-12 col-sm-6">
                        <div className="menu_item menupadding text-center">
                          <div className="menu_title">
                            <h3>MIX FRUIT PUNCH</h3>
                          </div>
                        </div>
                      </div>
                      <div className="col-12 col-sm-6">
                        <div className="menu_item menupadding text-center">
                          <div className="menu_title">
                            <h3>LIME</h3>
                          </div>
                        </div>
                      </div>
                      <div className="col-12 col-sm-6">
                        <div className="menu_item menupadding text-center">
                          <div className="menu_title">
                            <h3>LIME & SODA</h3>
                          </div>
                        </div>
                      </div>
                      <div className="col-12 col-sm-6">
                        <div className="menu_item menupadding text-center">
                          <div className="menu_title">
                            <h3>KING COCONUT</h3>
                          </div>
                        </div>
                      </div>
                      <div className="col-12 col-sm-6">
                        <div className="menu_item menupadding text-center">
                          <div className="menu_title">
                            <h3>LASSIE (SWEET | SALT)</h3>
                          </div>
                        </div>
                      </div>
                      <div className="col-12 col-sm-6">
                        <div className="menu_item menupadding text-center">
                          <div className="menu_title">
                            <h3>BE MY HONEY (SMOOTHIE)</h3>
                          </div>
                        </div>
                      </div>
                      <div className="col-12 col-sm-6">
                        <div className="menu_item menupadding text-center">
                          <div className="menu_title">
                            <h3>MILK SHAKE<br />(CHOCO | VANILLA | STRAWBERRY)</h3>
                          </div>
                        </div>
                      </div>
                      <p className="col-12 darkcolor">ALL PRICES ARE IN LKR & SUBJECT TO 10% SERVICE CHARGE + 01% GOVERNMENT TAX</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Desktop tabs (visible ≥ lg) */}
          <div className={`tabs_menu animate-slide-up d-none d-lg-block ${isVisible ? 'animate-visible' : ''}`} style={{ animationDelay: '0.3s' }}>
            <ul className="nav nav-tabs" role="tablist">
              <li className="nav-item">
                  <button 
                    className={`nav-link ${activeTab === 'A' ? 'active' : ''}`}
                    onClick={() => handleTabChange('A')}
                  >
                    Breakfast
                  </button>
              </li>
              <li className="nav-item">
                  <button 
                    className={`nav-link ${activeTab === 'B' ? 'active' : ''}`}
                    onClick={() => handleTabChange('B')}
                  >
                    All day dining
                  </button>
              </li>
              <li className="nav-item">
                  <button 
                    className={`nav-link ${activeTab === 'C' ? 'active' : ''}`}
                    onClick={() => handleTabChange('C')}
                  >
                    Young Traveller
                  </button>
              </li>
              <li className="nav-item">
                  <button 
                    className={`nav-link ${activeTab === 'D' ? 'active' : ''}`}
                    onClick={() => handleTabChange('D')}
                  >
                    Drinks
                  </button>
              </li>
              <li className="nav-item">
                  <button 
                    className={`nav-link ${activeTab === 'E' ? 'active' : ''}`}
                    onClick={() => handleTabChange('E')}
                  >
                    Non Alcoholic
                  </button>
              </li>
            </ul>
            <div className="tab-content add_bottom_25" role="tablist">
                {/* Breakfast Tab */}
                {activeTab === 'A' && (
                  <div className="card tab-pane fade show active" role="tabpanel">
                    <div className="card-header" role="tab">
                      <h5>
                        <span>BREAKFAST</span>
                  </h5>
                </div>
                    <div className="collapse show" role="tabpanel">
                  <div className="card-body text-center">
                    <div className="row magnific-gallery add_top_30">
                      <div className="col-6">
                            <div className="menu_item menupadding text-center">
                          <div className="menu_title">
                            <h3>RISE & SHINE</h3>
                          </div>
                          <p>Cheese | Baked Beans | Tomato | Spinach | Mushroom<br />Chicken Sausage | Bacon | Toast Bread | Jam | Butter</p>
                        </div>
                      </div>
                      <div className="col-6">
                        <div className="menu_item menupadding">
                          <div className="menu_title">
                            <h3>EGGS BENEDICT & CRIPSY COCNUT SAMBAL</h3>
                          </div>
                          <p>Egg | Bacon | Spinach | Coconut</p>
                        </div>
                      </div>
                      <div className="col-6">
                        <div className="menu_item menupadding">
                          <div className="menu_title">
                            <h3>TROPICAL GRANOLA BOWL</h3>
                          </div>
                          <p>Yoghurt | Museli | Tropical Fresh Fruits</p>
                        </div>
                      </div>
                      <div className="col-6">
                        <div className="menu_item menupadding">
                          <div className="menu_title">
                            <h3>AVOCADO & PUMPKIN TOAST<br />WITH POACHED EGG</h3>
                          </div>
                          <p>Multigrain Bread | Avocado | Egg | Tahini Paste | Pumpkin</p>
                        </div>
                      </div>
                      <div className="col-6">
                        <div className="menu_item menupadding">
                          <div className="menu_title">
                            <h3>FRENCH TOAST WITH KITHUL TREACLE</h3>
                          </div>
                          <p>Cinnamon | Strawberry | Banana | Ice Cream | Treacle</p>
                        </div>
                      </div>
                      <div className="col-6">
                        <div className="menu_item menupadding">
                          <div className="menu_title">
                            <h3>TURKISH STYLE EGG</h3>
                          </div>
                          <p>Egg | Yogurt | Chilli Oil | Multigrain Bread</p>
                        </div>
                      </div>
                      <div className="col-6">
                        <div className="menu_item menupadding">
                          <div className="menu_title">
                            <h3>MILK RICE IN COCONUT PRAWN<br />WITH CARAMELIZED ONION</h3>
                          </div>
                          <p>Prawn | Milk Rice | Coconut Milk | Caramelized Onion</p>
                        </div>
                      </div>
                      <div className="col-6">
                        <div className="menu_item menupadding">
                          <div className="menu_title">
                            <h3>STRING HOPPERS</h3>
                          </div>
                          <p>Dhal | Coconut Sambal | (Chicken/Fish)</p>
                        </div>
                      </div>
                      <div className="col-12 title text-center mb-5">
                        <h3 className="darkcolor">ADD ONS</h3>
                      </div>
                      <div className="col-6">
                        <div className="menu_item menupadding">
                          <div className="menu_title">
                            <h3>CHILLI BACON BUTTER</h3>
                          </div>
                        </div>
                      </div>
                      <div className="col-6">
                        <div className="menu_item menupadding">
                        <div className="menu_title">
                            <h3>BROWN TOAST</h3>
                          </div>
                        </div>
                      </div>
                      <div className="col-6">
                        <div className="menu_item menupadding">
                          <div className="menu_title">
                            <h3>PUMPKIN HUMMUS</h3>
                          </div>
                        </div>
                      </div>
                      <div className="col-6">
                        <div className="menu_item menupadding">
                          <div className="menu_title">
                            <h3>EGG ANY STYLE</h3>
                          </div>
                        </div>
                      </div>
                      <p className="col-12 darkcolor">ALL PRICES ARE IN LKR & SUBJECT TO 10% SERVICE CHARGE + 01% GOVERNMENT TAX</p>
                    </div>
                  </div>
                </div>
              </div>
                )}

                {/* All Day Dining Tab */}
                {activeTab === 'B' && (
                  <div className="card tab-pane fade show active" role="tabpanel">
                    <div className="card-header" role="tab">
                      <h5>
                        <span>ALL DAY DINING</span>
                      </h5>
                    </div>
                    <div className="collapse show" role="tabpanel">
                      <div className="card-body text-center">
                        <div className="row magnific-gallery add_top_30">
                          <div className="col-12">
                            <div className="title text-center mb-5">
                              <h3 className="darkcolor">APPETIZER</h3>
                            </div>
                          </div>
                          <div className="col-6">
                            <div className="menu_item menupadding text-center">
                              <div className="menu_title">
                                <h3>SWEET POTATO NACHOS</h3>
                              </div>
                              <p>Sweet potato | Sour cream | Guacamole | Cheese</p>
                            </div>
                          </div>
                          <div className="col-6">
                            <div className="menu_item menupadding text-center">
                              <div className="menu_title">
                                <h3>LEMONGRASS & CURRY INFUSED CHICKEN SKEWERS</h3>
                              </div>
                              <p>Chicken | Peanut butter | Lemongrass</p>
                            </div>
                          </div>
                          <div className="col-6">
                            <div className="menu_item menupadding text-center">
                              <div className="menu_title">
                                <h3>PRAWN ROTI</h3>
                              </div>
                              <p>Prawns | Cheese | Bell peppers | Tamarind</p>
                            </div>
                          </div>
                          <div className="col-6">
                            <div className="menu_item menupadding text-center">
                              <div className="menu_title">
                                <h3>MANIOC ARANCINI</h3>
                              </div>
                              <p>Manioc | Cheese | Spiced kochchi</p>
                            </div>
                          </div>
                          <div className="col-6">
                            <div className="menu_item menupadding text-center">
                              <div className="menu_title">
                                <h3>TUNA SASHIMI</h3>
                              </div>
                              <p>Yellowfin tuna | Pickle ginger | Radish | Wasabi | Greens</p>
                            </div>
                          </div>
                          <div className="col-6">
                            <div className="menu_item menupadding text-center">
                              <div className="menu_title">
                                <h3>TUNA TARTARE</h3>
                              </div>
                              <p>Yellowfin tuna | Avocado | Lemon | Cilantro | Sesame</p>
                            </div>
                          </div>
                          <div className="col-12 title text-center mb-5">
                            <h3 className="darkcolor">SALADS</h3>
                          </div>
                          <div className="col-6">
                            <div className="menu_item menupadding text-center">
                              <div className="menu_title">
                                <h3>POACHED YELLOWFIN TUNA</h3>
                              </div>
                              <p>Yellowfin tuna | Greens | Tomato | Beans | Tamarind | Jaggery</p>
                            </div>
                          </div>
                          <div className="col-6">
                            <div className="menu_item menupadding text-center">
                              <div className="menu_title">
                                <h3>ASIAN FLAVORED PRAWN NOODLES SALAD</h3>
                              </div>
                              <p>Prawns | Kurakkan noodles | Cilantro | Mango | Sesame oil | Spring onion</p>
                            </div>
                          </div>
                          <div className="col-6">
                            <div className="menu_item menupadding text-center">
                              <div className="menu_title">
                                <h3>BHEALTHY GREENS WITH TROPICAL FRUITS</h3>
                              </div>
                              <p>Greens | Gotukola | Fruits</p>
                            </div>
                          </div>
                          <div className="col-12 title text-center mb-5">
                            <h3 className="darkcolor">SOUP</h3>
                          </div>
                          <div className="col-6">
                            <div className="menu_item menupadding text-center">
                              <div className="menu_title">
                                <h3>LEMONGRASS & CRAYFISH BISQUE</h3>
                              </div>
                              <p>Crayfish | Lemongrass | Tomato</p>
                            </div>
                          </div>
                          <div className="col-6">
                            <div className="menu_item menupadding text-center">
                              <div className="menu_title">
                                <h3>COCONUT SEAFOOD BROTH</h3>
                              </div>
                              <p>Mixed seafood | Curry coconut cream</p>
                            </div>
                          </div>
                          <div className="col-6">
                            <div className="menu_item menupadding text-center">
                              <div className="menu_title">
                                <h3>ORANGE FLAVORED CARROT SOUP</h3>
                              </div>
                              <p>Carrot | Orange | Habalapeti</p>
                            </div>
                          </div>
                          <div className="col-12 title text-center mb-5">
                            <h3 className="darkcolor">SIDE DISHES</h3>
                          </div>
                          <div className="col-6">
                            <div className="menu_item menupadding text-center">
                              <div className="menu_title">
                                <h3>HOME-MADE FRIES</h3>
                              </div>
                            </div>
                          </div>
                          <div className="col-6">
                            <div className="menu_item menupadding text-center">
                              <div className="menu_title">
                                <h3>SWEET POTATO FRIES</h3>
                              </div>
                            </div>
                          </div>
                          <div className="col-6">
                            <div className="menu_item menupadding text-center">
                              <div className="menu_title">
                                <h3>GARLIC TOAST</h3>
                              </div>
                            </div>
                          </div>
                          <div className="col-6">
                            <div className="menu_item menupadding text-center">
                              <div className="menu_title">
                                <h3>LEMONGRASS FLOURED SAFFRON RICE BOWL</h3>
                              </div>
                            </div>
                          </div>
                          <div className="col-12 title text-center mb-5">
                            <h3 className="darkcolor">HANDHELDS</h3>
                          </div>
                          <div className="col-6">
                            <div className="menu_item menupadding text-center">
                              <div className="menu_title">
                                <h3>CRISPY CHICKEN BURGER</h3>
                              </div>
                              <p>Chicken | Cheese | Tomato | Lettuce | Fries</p>
                            </div>
                          </div>
                          <div className="col-6">
                            <div className="menu_item menupadding text-center">
                              <div className="menu_title">
                                <h3>BEEF BURGER</h3>
                              </div>
                              <p>Beef | Caramalized onion | Cheese | Lettuce | Tomato | Fries</p>
                            </div>
                          </div>
                          <div className="col-6">
                            <div className="menu_item menupadding text-center">
                              <div className="menu_title">
                                <h3>PRAWN BURGER</h3>
                              </div>
                              <p>Prawn | Cheese | Lettuce | Tomato | Fries</p>
                            </div>
                          </div>
                          <div className="col-6">
                            <div className="menu_item menupadding text-center">
                              <div className="menu_title">
                                <h3>POLOS BURGER</h3>
                              </div>
                              <p>Baby jack fruit | Caramelized onion | Cheese | Passion leaves | Fries</p>
                            </div>
                          </div>
                          <div className="col-12 title text-center mb-5">
                            <h3 className="darkcolor">MAINS</h3>
                          </div>
                          <div className="col-6">
                            <div className="menu_item menupadding text-center">
                              <div className="menu_title">
                                <h3>CURRY GRAVY IN JUMBO PRAWN & PITTU</h3>
                              </div>
                              <p>Jumbo prawn | Coconut cream | Casava pittu | Kankun</p>
                            </div>
                          </div>
                          <div className="col-6">
                            <div className="menu_item menupadding text-center">
                              <div className="menu_title">
                                <h3>SEAFOOD PLATTER</h3>
                              </div>
                              <p>Jumbo prawns | Fish steak | Calamari | Crab | Fries | Greens salad | Garlic butter sauce</p>
                            </div>
                          </div>
                          <div className="col-6">
                            <div className="menu_item menupadding text-center">
                              <div className="menu_title">
                                <h3>GRILLED FILLET BARRAMUNDI & SALSA VERDE</h3>
                              </div>
                              <p>Potato | Spinach | Aper butter | Salsa verde</p>
                            </div>
                          </div>
                          <div className="col-6">
                            <div className="menu_item menupadding text-center">
                              <div className="menu_title">
                                <h3>YELLOWFIN TUNA STEAK</h3>
                              </div>
                              <p>Yellowfin tuna | Saffron rice | Mango salsa | Gotukola | Lemon butter</p>
                            </div>
                          </div>
                          <div className="col-6">
                            <div className="menu_item menupadding text-center">
                              <div className="menu_title">
                                <h3>POT-ROAST CHICKEN THIGH (BONELESS)</h3>
                              </div>
                              <p>Sri Lankan spices | Chicken | Pumpkin | Broccoli | Green pepper sauce</p>
                            </div>
                          </div>
                          <div className="col-6">
                            <div className="menu_item menupadding text-center">
                              <div className="menu_title">
                                <h3>PORK CURRY WITH POL ROTI</h3>
                              </div>
                              <p>Pork | Sri Lankan spices | Coconut sambal</p>
                            </div>
                          </div>
                          <div className="col-6">
                            <div className="menu_item menupadding text-center">
                              <div className="menu_title">
                                <h3>SEAFOOD HOT POT & CRUSTY BREAD</h3>
                              </div>
                              <p>Crab | Fish | Cuttlefish | Prawns | Bread | Coconut gravy | Pol sambal</p>
                            </div>
                          </div>
                          <div className="col-6">
                            <div className="menu_item menupadding text-center">
                              <div className="menu_title">
                                <h3>FETTUCCINE IN SPICED LOKU PRAWNS CURRY SAUCE</h3>
                              </div>
                              <p>Loku (big) prawns | Cheese | Fettuccine | Coconut cream</p>
                            </div>
                          </div>
                          <div className="col-6">
                            <div className="menu_item menupadding text-center">
                              <div className="menu_title">
                                <h3>LEMON & GARLIC MARINATED GRILLED CALAMARI</h3>
                              </div>
                              <p>Loku (big) prawns | Cheese | Fettuccine | Coconut cream</p>
                            </div>
                          </div>
                          <div className="col-6">
                            <div className="menu_item menupadding text-center">
                              <div className="menu_title">
                                <h3>PRAWN RISOTTO</h3>
                              </div>
                              <p>Loku (big) prawns | Cheese | Fettuccine | Coconut cream</p>
                            </div>
                          </div>
                          <div className="col-6">
                            <div className="menu_item menupadding text-center">
                              <div className="menu_title">
                                <h3>SPAGHETTI WITH SPICED CRAB MEAT</h3>
                              </div>
                              <p>Crab meat | Spaghetti | Chili | Cheese</p>
                            </div>
                          </div>
                          <div className="col-6">
                            <div className="menu_item menupadding text-center">
                              <div className="menu_title">
                                <h3>PASTA ARRABIATA</h3>
                              </div>
                              <p>Penne | Fresh tomato | Chili | Parmesan cheese | Basil</p>
                            </div>
                          </div>
                          <div className="col-6">
                            <div className="menu_item menupadding text-center">
                              <div className="no_menu_title">
                                <h3>RICE & CURRY BOWL</h3>
                              </div>
                              <p>Typical rice & curry served with four veg curries salad and papadam
                                <ul>
                                  <li className="menu_title"><h6>- Prawns</h6></li>
                                  <li className="menu_title"><h6>- Fish</h6></li>
                                  <li className="menu_title"><h6>- Crabs</h6></li>
                                  <li className="menu_title"><h6>- Chicken</h6></li>
                                  <li className="menu_title"><h6>- Vegetable</h6></li>
                                </ul>
                              </p>
                            </div>
                          </div>
                          <div className="col-12 title text-center mb-5">
                            <h3 className="darkcolor">DESSERTS</h3>
                          </div>
                          <div className="col-6">
                            <div className="menu_item menupadding text-center">
                              <div className="menu_title">
                                <h3>COCONUT CRÈME BRULEE</h3>
                              </div>
                              <p>Coconut | Crème</p>
                            </div>
                          </div>
                          <div className="col-6">
                            <div className="menu_item menupadding text-center">
                              <div className="menu_title">
                                <h3>MANGO TIRAMISU</h3>
                              </div>
                              <p>Mascarpone cheese | Cocoa | Kahlua | Mango</p>
                            </div>
                          </div>
                          <div className="col-6">
                            <div className="menu_item menupadding text-center">
                              <div className="menu_title">
                                <h3>CHOCOLATE BROWNIE</h3>
                              </div>
                              <p>Chocolate | Cashew | Ice cream</p>
                            </div>
                          </div>
                          <div className="col-6">
                            <div className="menu_item menupadding text-center">
                              <div className="menu_title">
                                <h3>CARAMELIZED COCONUTS WITH CHOCOLATE CREPES</h3>
                              </div>
                              <p>Chocolate | Caramelized coconut | Ice cream</p>
                            </div>
                          </div>
                          <div className="col-6">
                            <div className="menu_item menupadding text-center">
                              <div className="menu_title">
                                <h3>CHOICE OF ICE CREAM</h3>
                              </div>
                            </div>
                          </div>
                          <p className="col-12 darkcolor">ALL PRICES ARE IN LKR & SUBJECT TO 10% SERVICE CHARGE + 01% GOVERNMENT TAX</p>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {/* Young Traveller Tab */}
                {activeTab === 'C' && (
                  <div className="card tab-pane fade show active" role="tabpanel">
                    <div className="card-header" role="tab">
                      <h5>
                        <span>YOUNG TRAVELER</span>
                      </h5>
                    </div>
                    <div className="collapse show" role="tabpanel">
                      <div className="card-body text-center">
                        <div className="row magnific-gallery add_top_30">
                          <div className="col-6">
                            <div className="menu_item menupadding text-center">
                              <div className="menu_title">
                                <h3>SPAGHETTI CARBONARA</h3>
                              </div>
                            </div>
                          </div>
                          <div className="col-6">
                            <div className="menu_item menupadding text-center">
                              <div className="menu_title">
                                <h3>POTATO MASHED WITH GRILLED SAUSAGE</h3>
                              </div>
                            </div>
                          </div>
                          <div className="col-6">
                            <div className="menu_item menupadding text-center">
                              <div className="menu_title">
                                <h3>CHEESE CHICKEN BURGER WITH FRIES</h3>
                              </div>
                            </div>
                          </div>
                          <div className="col-6">
                            <div className="menu_item menupadding text-center">
                              <div className="menu_title">
                                <h3>MAC & CHEESE</h3>
                              </div>
                            </div>
                          </div>
                          <div className="col-6">
                            <div className="menu_item menupadding text-center">
                              <div className="menu_title">
                                <h3>FISH FINGERS WITH FRIES</h3>
                              </div>
                            </div>
                          </div>
                          <p className="col-12 darkcolor">ALL PRICES ARE IN LKR & SUBJECT TO 10% SERVICE CHARGE + 01% GOVERNMENT TAX</p>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {/* Drinks Tab */}
                {activeTab === 'D' && (
                  <div className="card tab-pane fade show active" role="tabpanel">
                    <div className="card-header" role="tab">
                      <h5>
                        <span>DRINKS</span>
                      </h5>
                    </div>
                    <div className="collapse show" role="tabpanel">
                      <div className="card-body text-center">
                        <div className="row magnific-gallery add_top_30">
                          <div className="col-12 title text-center mb-5">
                            <h3 className="darkcolor">COCKTAILS</h3>
                          </div>
                          <div className="col-6">
                            <div className="menu_item menupadding text-center">
                              <div className="menu_title">
                                <h3>ORYZA FIZZ</h3>
                              </div>
                              <p>Gin | Ginger | Lemon Grass | Sprite</p>
                            </div>
                          </div>
                          <div className="col-6">
                            <div className="menu_item menupadding text-center">
                              <div className="menu_title">
                                <h3>PETTI PASSION</h3>
                              </div>
                              <p>Arrack | Passion | Pineapple | Mint | Soda</p>
                            </div>
                          </div>
                          <div className="col-6">
                            <div className="menu_item menupadding text-center">
                              <div className="menu_title">
                                <h3>MIRISSA ACHCHARUWA</h3>
                              </div>
                              <p>Gin | Triple Sec | Lime | Local Achcharu</p>
                            </div>
                          </div>
                          <div className="col-6">
                            <div className="menu_item menupadding text-center">
                              <div className="menu_title">
                                <h3>CURRY MELON TEQUILA</h3>
                              </div>
                              <p>Tequila | Watermelon | Lime | Sugar</p>
                            </div>
                          </div>
                          <div className="col-6">
                            <div className="menu_item menupadding text-center">
                              <div className="menu_title">
                                <h3>CINNAMON TWIST</h3>
                              </div>
                              <p>Vodka | Triple Sec | Lime | Cinnamon</p>
                            </div>
                          </div>
                          <div className="col-6">
                            <div className="menu_item menupadding text-center">
                              <div className="menu_title">
                                <h3>ESPRESSO MILO TINI</h3>
                              </div>
                              <p>Vodka | Caoco brown | Expresso | Milo</p>
                            </div>
                          </div>
                          <div className="col-12 title text-center mb-5">
                            <h3 className="darkcolor">WINE</h3>
                          </div>
                          <div className="col-12 title text-center mb-5">
                            <h4>WHITE WINE</h4>
                          </div>
                          <div className="col-6">
                            <div className="menu_item menupadding text-center">
                              <div className="menu_title">
                                <h3 className="upper">Cono Sur Bicicleta Sauvignon Blanc, Chile</h3>
                              </div>
                            </div>
                          </div>
                          <div className="col-6">
                            <div className="menu_item menupadding text-center">
                              <div className="menu_title">
                                <h3 className="upper">Paraiso White, Chile</h3>
                              </div>
                            </div>
                          </div>
                          <div className="col-6">
                            <div className="menu_item menupadding text-center">
                              <div className="menu_title">
                                <h3 className="upper">Yellow tail Sauvignon Blanc, Australia</h3>
                              </div>
                            </div>
                          </div>
                          <div className="col-6">
                            <div className="menu_item menupadding text-center">
                              <div className="menu_title">
                                <h3 className="upper">Dr. Loosen Riesling, Germany</h3>
                              </div>
                            </div>
                          </div>
                          <div className="col-6">
                            <div className="menu_item menupadding text-center">
                              <div className="menu_title">
                                <h3 className="upper">Santa Margherita Pinot Grigio DOC, Italy</h3>
                              </div>
                            </div>
                          </div>
                          <div className="col-12 title text-center mb-5">
                            <h4>RED WINE</h4>
                          </div>
                          <div className="col-6">
                            <div className="menu_item menupadding text-center">
                              <div className="menu_title">
                                <h3 className="upper">Cono Sur Bicicleta Cabernet Sauvignon</h3>
                              </div>
                            </div>
                          </div>
                          <div className="col-6">
                            <div className="menu_item menupadding text-center">
                              <div className="menu_title">
                                <h3 className="upper">Paraiso Red, Chile</h3>
                              </div>
                            </div>
                          </div>
                          <div className="col-6">
                            <div className="menu_item menupadding text-center">
                              <div className="menu_title">
                                <h3 className="upper">Tall Horse Pinotage, South Africa</h3>
                              </div>
                            </div>
                          </div>
                          <div className="col-12 title text-center mb-5">
                            <h4>ROSÉ WINE</h4>
                          </div>
                          <div className="col-6">
                            <div className="menu_item menupadding text-center">
                              <div className="menu_title">
                                <h3 className="upper">Jam Jar Sweet Blush, South Africa</h3>
                              </div>
                            </div>
                          </div>
                          <div className="col-6">
                            <div className="menu_item menupadding text-center">
                              <div className="menu_title">
                                <h3 className="upper">Torresella Pinot Grigio Rose, Italy</h3>
                              </div>
                            </div>
                          </div>
                          <div className="col-12 title text-center mb-5">
                            <h4>SPARKLING / CHAMPAGNE</h4>
                          </div>
                          <div className="col-6">
                            <div className="menu_item menupadding text-center">
                              <div className="menu_title">
                                <h3 className="upper">EGOS Spumante Brut, Italy</h3>
                              </div>
                            </div>
                          </div>
                          <div className="col-6">
                            <div className="menu_item menupadding text-center">
                              <div className="menu_title">
                                <h3 className="upper">Torresella Prosecco, Italy</h3>
                              </div>
                            </div>
                          </div>
                          <div className="col-6">
                            <div className="menu_item menupadding text-center">
                              <div className="menu_title">
                                <h3 className="upper">Jacquart Brut Mosaique, France</h3>
                              </div>
                            </div>
                          </div>
                          <div className="col-6">
                            <div className="menu_item menupadding text-center">
                              <div className="menu_title">
                                <h3 className="upper">Pierre Mignon Grande Reserve Brut, France</h3>
                              </div>
                            </div>
                          </div>
                          <div className="col-6">
                            <div className="menu_item menupadding text-center">
                              <div className="menu_title">
                                <h3 className="upper">Pierre Mignon Rose Brut, France</h3>
                              </div>
                            </div>
                          </div>
                          <div className="col-6">
                            <div className="menu_item menupadding text-center">
                              <div className="menu_title">
                                <h3 className="upper">Moet Chandon Brut, France</h3>
                              </div>
                            </div>
                          </div>
                          <p className="col-12 darkcolor">ALL PRICES ARE IN LKR & SUBJECT TO 10% SERVICE CHARGE + 01% GOVERNMENT TAX</p>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {/* Non Alcoholic Tab */}
                {activeTab === 'E' && (
                  <div className="card tab-pane fade show active" role="tabpanel">
                    <div className="card-header" role="tab">
                      <h5>
                        <span>NON ALCOHOLIC</span>
                      </h5>
                    </div>
                    <div className="collapse show" role="tabpanel">
                      <div className="card-body text-center">
                        <div className="row magnific-gallery add_top_30">
                          <div className="col-6">
                            <div className="menu_item menupadding text-center">
                              <div className="menu_title">
                                <h3>VIRGIN PASSION MOJITO</h3>
                              </div>
                              <p>Passion | Mint | Lime | Sprite</p>
                            </div>
                          </div>
                          <div className="col-6">
                            <div className="menu_item menupadding text-center">
                              <div className="menu_title">
                                <h3>WATERMELON COOLER</h3>
                              </div>
                              <p>Watermelon | Mint | Lime</p>
                            </div>
                          </div>
                          <div className="col-6">
                            <div className="menu_item menupadding text-center">
                              <div className="menu_title">
                                <h3>FRESCO</h3>
                              </div>
                              <p>Ginger | Lime | Mint | Ginger ale</p>
                            </div>
                          </div>
                          <div className="col-6">
                            <div className="menu_item menupadding text-center">
                              <div className="menu_title">
                                <h3>CEYLON GINGER & MINT TEA</h3>
                              </div>
                              <p>Black tea | Ginger | Cinnamon | Mint | Sugar</p>
                            </div>
                          </div>
                          <div className="col-6">
                            <div className="menu_item menupadding text-center">
                              <div className="menu_title">
                                <h3>GREEN MINT TEA</h3>
                              </div>
                              <p>Green tea | Lime | Kithul treacle | Mint</p>
                            </div>
                          </div>
                          <div className="col-12">
                            <div className="title text-center mb-5">
                              <h3 className="darkcolor">JUICES</h3>
                            </div>
                          </div>
                          <div className="col-6">
                            <div className="menu_item menupadding text-center">
                              <div className="menu_title">
                                <h3>MANGO</h3>
                              </div>
                            </div>
                          </div>
                          <div className="col-6">
                            <div className="menu_item menupadding text-center">
                              <div className="menu_title">
                                <h3>PINEAPPLE | WATERMELON | PASSION</h3>
                              </div>
                            </div>
                          </div>
                          <div className="col-6">
                            <div className="menu_item menupadding text-center">
                              <div className="menu_title">
                                <h3>MIX FRUIT PUNCH</h3>
                              </div>
                            </div>
                          </div>
                          <div className="col-6">
                            <div className="menu_item menupadding text-center">
                              <div className="menu_title">
                                <h3>LIME</h3>
                              </div>
                            </div>
                          </div>
                          <div className="col-6">
                            <div className="menu_item menupadding text-center">
                              <div className="menu_title">
                                <h3>LIME & SODA</h3>
                              </div>
                            </div>
                          </div>
                          <div className="col-6">
                            <div className="menu_item menupadding text-center">
                              <div className="menu_title">
                                <h3>KING COCONUT</h3>
                              </div>
                            </div>
                          </div>
                          <div className="col-6">
                            <div className="menu_item menupadding text-center">
                              <div className="menu_title">
                                <h3>LASSIE (SWEET | SALT)</h3>
                              </div>
                            </div>
                          </div>
                          <div className="col-6">
                            <div className="menu_item menupadding text-center">
                              <div className="menu_title">
                                <h3>BE MY HONEY (SMOOTHIE)</h3>
                              </div>
                            </div>
                          </div>
                          <div className="col-6">
                            <div className="menu_item menupadding text-center">
                              <div className="menu_title">
                                <h3>MILK SHAKE<br />(CHOCO | VANILLA | STRAWBERRY)</h3>
                              </div>
                            </div>
                          </div>
                          <p className="col-12 darkcolor">ALL PRICES ARE IN LKR & SUBJECT TO 10% SERVICE CHARGE + 01% GOVERNMENT TAX</p>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
            </div>
          </div>
        </div>
      </div>
      </main>
    </>
  );
};

export default Dining;